export default __webpack_public_path__ + "static/latitudefenix-5a81b37ce8adce5cdf9bfc10d32efd32.webp";